import { render, staticRenderFns } from "./Mocustomers.vue?vue&type=template&id=21cbba56&"
import script from "./Mocustomers.vue?vue&type=script&lang=js&"
export * from "./Mocustomers.vue?vue&type=script&lang=js&"
import style0 from "./Mocustomers.vue?vue&type=style&index=0&id=21cbba56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports